// Figure d'illustration : image AFFICHÉE EN ENTIER (jamais recadrée),
// légende + crédit cliquable vers la page source Wikimedia Commons.
// entry : { src, w, h, alt, caption, credit, creditUrl }
export const IlluFigure = ({ entry, testId, className = "" }) => (
  <figure className={`img-content-figure ${className}`} data-testid={testId}>
    <img
      src={entry.src}
      alt={entry.alt}
      width={entry.w}
      height={entry.h}
      loading="lazy"
      className="img-content border border-ink/15"
    />
    <figcaption className="mt-3 font-mono text-[11px] font-light leading-relaxed tracking-wide text-smoke">
      {entry.caption}{" "}
      <a
        href={entry.creditUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId ? `${testId}-credit` : undefined}
        className="text-bronze underline-offset-4 transition-colors hover:underline"
      >
        {entry.credit}
      </a>
    </figcaption>
  </figure>
);
